import { IQueryClientConfig } from '../CRUD';

const getQueryConfig = (): IQueryClientConfig => ({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

export default getQueryConfig;
